import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';

import Icon from '../../../../../assets/images/pro/amazon-pay@2x.png';

import * as styles from '../styles/styles.module.scss';

const PayWithAmazonButton = ({ text, handler }) => {
  const content = (
    <span className={styles.contents}>
      {text}
      <img className={styles.amazonPayIcon} src={Icon} />
    </span>
  );

  return <SubmitButton text={content} handler={handler} variant="amazonCheckout" />;
};

PayWithAmazonButton.propTypes = {
  text: PropTypes.element.isRequired,
  handler: PropTypes.func.isRequired
};

export default PayWithAmazonButton;
